import { Collapse, Zoom } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

export const Shrink: React.FC<TransitionProps & { children: JSX.Element }> = ({ children, ...transitionProps }) =>
    <Collapse {...transitionProps} style={{ transitionDelay: transitionProps.in ? '0ms' : '250ms' }}>
        <Zoom {...transitionProps} style={{ transitionDelay: transitionProps.in ? '250ms' : '0ms' }}>
            {children}
        </Zoom>
    </ Collapse>;